import api from '@api'

// initial state
const state = {}

// getters
const getters = {}

// actions
const actions = {
  updatePlatformUserProvince ({commit, state}, params) {
    let promised = api.updatePlatformUserProvince(params)
    return promised
  },
  getPlatformUsersProvince ({commit, state}, params) {
    let promised = api.getPlatformUsersProvince(params)
    return promised
  },
}

// mutations
const mutations = {}

export const platformUserProvince = {
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/views/platform-user-province/platform-user-province.store.js